import Modal, { ModalProps } from "../../layouts/Modal";
import { IAccount } from "../../models/account/IAccount";
import { AccountCreateEditForm } from "./AccountCreateEditForm";

interface AccountCreateEditModalProps
  extends Omit<ModalProps, "children" | "width"> {
  account?: IAccount;
  newAccountName?: string;
  presetHaulier?: boolean;
  onCreated?: (account: IAccount) => void;
}

export function AccountCreateEditModal({
  open,
  setOpen,
  account,
  newAccountName,
  presetHaulier,
  onCreated,
}: AccountCreateEditModalProps) {
  return (
    <Modal width="max-w-[1500px]" open={open} setOpen={setOpen}>
      <AccountCreateEditForm
        account={account}
        newAccountName={newAccountName}
        presetHaulier={presetHaulier}
        onCreated={onCreated}
        onSaved={() => setOpen(false)}
      />
    </Modal>
  );
}
